import "../App.css";
import PrivacyPageDisplay from "../components/PrivacyPage/PrivacyPageDisplay";

const Privacy = () => {
  return (
    <div className="App">
      <header className="App-header">
        <PrivacyPageDisplay/>
      </header>
    </div>
  );
};
export default Privacy;
